/**
 * Owner: Masa Bayu
 * File: qxcircle-home-data.ts
 * Date:Time: 2026-09-18 11:00
 * Description: QXCircle Visual Home — Owner banner (Vite-bundled) · section copy.
 */

import bannerSrc from '../../assets/qxcircle/banner.png';
import { PRODUCT_ROUTES } from '../platform/routes';

/** Owner QXCircle banner — 2048×768 PNG (same ratio as Home). */
export const CIRCLE_HERO_BANNER = {
  src: bannerSrc,
  alt: 'QX Circle — Connect · discover · share. Your circle. Your community. Your world.',
  href: PRODUCT_ROUTES.qxcircle,
  width: 2048,
  height: 768,
} as const;

export const CIRCLE_HOME_COPY = {
  eyebrow: 'QXCircle',
  feedTitle: 'Feed',
  heroTitle: 'Connect · discover · share',
} as const;
